// extracted by mini-css-extract-plugin
export default {"enterEmailPopup":"enter-email-popup_enterEmailPopup__1ou4A","submitButton":"enter-email-popup_submitButton__WWZ3B","oneTapWrapper":"enter-email-popup_oneTapWrapper__wutC0"};